const l = {
  name: "BallBasketball",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,40c11,0,20-9,20-20S31,0,20,0C9,0,0,9,0,20S9,40,20,40z M38,20.9c-0.2,4.3-1.9,8.1-4.6,11.1l-12-12
			l4.3-4.3C29.2,18.9,33.6,20.6,38,20.9z M27.1,14.3L33.4,8c2.6,2.9,4.3,6.7,4.5,10.9C34.1,18.6,30.2,17.1,27.1,14.3z M32,6.6
			l-6.3,6.3c-2.8-3.1-4.3-7-4.5-10.9C25.3,2.3,29.1,4,32,6.6z M24.3,14.3L20,18.6L8,6.6c3-2.7,6.9-4.4,11.1-4.6
			C19.4,6.5,21.1,10.8,24.3,14.3z M18.6,20l-4.3,4.3c-3.5-3.2-7.9-4.9-12.3-5.1C2.2,14.9,3.9,11,6.6,8L18.6,20z M12.9,25.7L6.6,32
			C4,29.1,2.3,25.3,2,21.1C5.9,21.4,9.8,22.9,12.9,25.7z M8,33.4l6.3-6.3c2.8,3.1,4.3,7,4.5,10.9C14.7,37.7,10.9,36,8,33.4z
			 M15.7,25.7l4.3-4.3l12,12c-3,2.7-6.9,4.4-11.1,4.6C20.6,33.6,18.9,29.2,15.7,25.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as BallBasketball
};
